import React from "react";
import { Link } from "react-router-dom";
import useNotebookSidebar from "./use-notebook-sidebar";
import PageRecord from "models/view-models/page-record";
import { Breakpoints } from "utilities/enumerations/breakpoints";
import useBreakpoint, {
    BreakpointComparer,
} from "utilities/hooks/use-breakpoint";
import useToggleNotebookSidebar from "../use-toggle-notebook-sidebar";
import PageContextMenu from "pages/notebooks/pages/page-context-menu";

interface PagePanelProps {
    notebookId: number;
    page: PageRecord;
}

const BASE_CLASS_NAME = "c-notebook-sidebar";

const PagePanel = ({ page, notebookId }: PagePanelProps) => {
    const { pageRoute, getPageClassModifier } = useNotebookSidebar();
    const { toggleDisplay } = useToggleNotebookSidebar();
    const isMobile = useBreakpoint(
        Breakpoints.SmallTablet,
        BreakpointComparer.MaxWidth
    );
    const closeIfSidebarMobile = () => {
        if (isMobile) {
            toggleDisplay();
        }
    };
    return (
        <div
            className={`${BASE_CLASS_NAME}__pagePanel ${getPageClassModifier(page.id!)}`}>
            <Link
                to={pageRoute(page.id!, notebookId)!}
                className={`${BASE_CLASS_NAME}__link -page`}
                onClick={closeIfSidebarMobile}>
                <span>{page.name}</span>
            </Link>
            <div className={`${BASE_CLASS_NAME}__menu`}>
                <PageContextMenu
                    showOpenAction
                    showShareAction
                    page={page}
                    isViewOnly={false}
                />
            </div>
        </div>
    );
};

export default PagePanel;
